import {KeyboardEventHandler, MouseEventHandler, useState} from 'react';

import {SearchRequest} from '../../../../../api/types/__generated__/data-contracts';
import {useSnackbar} from '../../../../snackbars/snackbars';
import {
    ErrorCase, SearchErrorCases, validateSearchForm
} from '../search-validation';

type FormState = {
    value: SearchRequest | null
    isValid: boolean
    errors: SearchErrorCases | {}
}

type HookOptions = {
    onSearch: (request: SearchRequest) => any
}

export const useSearchControls = ({ onSearch }: HookOptions) => {
    const { enqueueSnackbar } = useSnackbar();
    const [state, setState] = useState<FormState>({
        value: null,
        errors: {},
        isValid: true
    });

    const handleChange = (id: string) => (e: any) => {
        const value: SearchRequest = {
            ...state.value || {academicYear: 0},
            [id]: e?.target?.value as any
        };
        // remove empty term string
        if (id === 'term' && e?.target?.value === '') {
            delete value.term
        }
        // type requires a zero to be present :/
        if (id === 'academicYear' && typeof value.academicYear === 'undefined') {
            value.academicYear = 0;
        }
        setState({ ...state, value });
    };

    const handleOnSubmitSearch: MouseEventHandler | KeyboardEventHandler = () => {
        const errors = validateSearchForm(state.value);
        setState({ ...state, errors });

        const isValid = Object.values(errors).length === 0;
        if (!isValid) {
            Object.values<ErrorCase>(errors).forEach(error => {
                enqueueSnackbar(error.message, { variant: 'error' });
            });
        }

        if (!isValid) {
            return;
        }

        onSearch(state.value as any);
    };

    return {
        state,
        onChange: handleChange,
        onSubmitSearch: handleOnSubmitSearch
    };
};
